import { Bookmark, BookmarkOutline } from '@lyearn/icons';

export const BOOKMARKED_CONFIG = {
  tooltipKey: 'ContentCards.RemoveBookmark',
  Icon: Bookmark,
};

export const NOT_BOOKMARKED_CONFIG = {
  tooltipKey: 'ContentCards.Bookmark',
  Icon: BookmarkOutline,
};
